{
  "pt": {
    "validation": {
      "emailTaken": "O endereço de correio eletrónico já está ocupado",
      "import": {
        "inclusion": "Erro na linha {rowNumber} coluna {columnNumber}: {headerName} não está incluído na lista",
        "inclusion_values": "com valores permitidos: {values}",
        "invalid": "Erro na linha {rowNumber} coluna {columnNumber}: {headerName} não é válido",
        "required": "Erro na linha {rowNumber} coluna {columnNumber}: é necessário um valor para {headerName} ",
        "unique": "Erro na linha {rowNumber}: {headerName} não é único, existe outra linha com este valor"
      },
      "nameAlreadyTaken": "O nome já está ocupado",
      "needCompany": "A empresa é obrigada",
      "needName": "O nome é obrigatório"
    }
  }
}
